// error-handler.service.ts
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PosthogService } from './posthog.service';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
    constructor(private messageService: MessageService, private posthogService: PosthogService) { }

    public handle(error: any, customMsg?: string) {
        // Tenta pegar status e mensagem do erro
        const status = error?.status;
        let detail =
            error?.error?.message ||
            error?.error?.details?.message ||
            customMsg ||
            error?.message ||
            'Ocorreu um erro inesperado';

        if (status === 500) {
            detail = 'Ops... Algo de errado aconteceu. Tente novamente mais tarde.';
        }
        if (status === 403) {
            detail = 'Não permitido';
        }

        //detail = detail + ' status: '+status;

        this.messageService.add({ severity: 'error', summary: 'Erro', detail });

        // Esse erro já foi tratado (não é uma exceção não tratada), então o
        // ErrorHandler/autocapture do PostHog nunca o veria sozinho — precisa
        // desse encaminhamento manual aqui, no ponto central por onde toda
        // requisição não-GET já passa (padrão obrigatório do projeto).
        this.posthogService.captureException(error);
    }

    public handleSocket() {
        let detail = `Erro de conexão ou socket`;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail });
    }
}
